import { degrees } from './degrees';

export const pathway = [
    {
        key: '3',
        name: 'What brings you to the Faculty of Education?',
        options: [
            {
                name: 'I want to become a K-12 teacher',
                value: '3.1.1',
                subHead: 'These degrees and programs offer pathways to becoming a K-12 teacher',
            },
            {
                name: 'I want to explore how the field of education can support my interests',
                value: '3.1.2',
            },
            {
                name: 'I want to become a counsellor',
                results: true,
                value: '3.1.3',
            },
        ]
    },

     // top level
     {
        key: '3.1.1',
        name: 'What best fits your work experience / history?',
        options: [
            {
                name: 'I am an internationally accredited teacher',
                value: '3.3.1',
            },
            {
                name: 'Current paraprofessional / currently working in the BC school system',
                value: '3.3.2',
            },
            {
                name: 'No professional teaching experience',
                value: '3.3.3',
            }
        ]
    },

    {
        key: '3.3.1',
        name: 'Are you interested in teaching in French?',
        options: [
            {
                name: 'Yes',
                results: true,
                value: '3.3.1-A-fr-yes',
            },
            {
                name: 'No',
                results: true,
                value: '3.3.1-B-fr-no',
            },
        ]
    },

    {
        key: '3.3.2',
        name: 'Are you interested in teaching in French?',
        options: [
            {
                name: 'Yes',
                results: true,
                value: '3.3.2-A-fr-yes',
            },
            {
                name: 'No',
                results: true,
                value: '3.3.2-B-fr-no',
            },
        ]
    },

    {
        key: '3.3.3',
        name: 'Are you interested in teaching in Ft. St. John or Dawson Creek?',
        options: [
            {
                name: 'Yes',
                results: true,
                value: '3.3.3-A-yes',
            },
            {
                name: 'No',
                value: '3.3.3-B-no',
            },
        ]
    },

    {
        key: '3.3.3-B-no',
        name: 'Are you interested in teaching in French?',
        options: [
            {
                name: 'Yes',
                results: true,
                value: '3.3.3-B.1-fr-yes',
            },
            {
                name: 'No',
                results: true,
                value: '3.3.3-B.1-fr-no',
            },
        ]
    },


     // top level
     {
        key: '3.1.2',
        name: 'What credential are you interested in?',
        options: [
            {
                name: 'Post Baccalaureate Diploma',
                value: '3.2.2.2',
            },
            {
                name: 'Master’s Degree',
                value: '3.2.2.1',
            },
            {
                name: 'Doctoral Degree',
                value: '6.1.2',
            },
        ]
    },

    {
        key: '3.2.2.1', // masters
        name: 'What areas of study are you interested in ?',
        type: 'checkbox',
        maxSelection: 3,
        options: [
            ...degrees.graduateStudies
        ]
    },

    {
        key: '3.2.2.2', // post bach
        name: 'What areas of study are you interested in ?',
        type: 'checkbox',
        maxSelection: 3,
        options: [
            ...degrees.postBach
        ]
    },
]

export const results = [
    {
        id: '3.3.1-A-fr-yes',
        primary: {
            links: [
                {
                    title: 'Professional Development Program (PDP) | French Module',
                    subtitle: 'SFU’s teacher education program',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/programmes-en-francais.html'
                },
                {
                    title: 'Professional Qualification Program (PQP)',
                    subtitle: 'For qualified teachers new to Canada',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/pqp/about.html'
                }
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Post Baccalaureate Diploma in French and Education',
                    url: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc/fr-edu-pbd.html'
                },
                {
                    title: 'Programmes en langue francaise',
                    url: 'https://www.sfu.ca/education/gs/futurestudents/areas-of-study/programsinfrench.html'
                },
                {
                    title: 'Graduate Diploma in Advanced Professional Studies in Education (GDE)',
                    url: 'https://www.sfu.ca/education/programs/diplomas/gde.html'
                }
            ]
        }
    },
    {
        id: '3.3.1-B-fr-no',
        primary: {
            links: [
                {
                    title: 'Professional Qualification Program (PQP)',
                    subtitle: 'For qualified teachers new to Canada',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/pqp/about.html',
                },
                {
                    title: 'Professional Development Program (PDP)',
                    subtitle: 'SFU’s teacher education program',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/pdp/about.html',
                }
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Graduate Diploma in Advanced Professional Studies in Education (GDE)',
                    url: 'https://www.sfu.ca/education/programs/diplomas/gde.html '
                },
                {
                    title: 'Post Baccalaureate Diplomas (PBD)',
                    url: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc.html'
                },
                {
                    title: 'Master’s Degree Programs',
                    url: 'https://www.sfu.ca/education/programs/graduate-studies.html'
                }
            ]
        }
    },
    {
        id: '3.3.2-A-fr-yes',
        primary: {
            links: [
                {
                    title: 'Professional Linking Program (PLP) | French Practicum',
                    subtitle: 'Flexible teacher education for working paraprofessionals',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/plp/about.html'
                },
                {
                    title: 'Professional Development Program (PDP) | French Module',
                    subtitle: 'SFU’s teacher education program',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/programmes-en-francais.html'
                }
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Post Baccalaureate Diploma in French and Education',
                    url: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc/fr-edu-pbd.html'
                },
                {
                    title: 'Programmes en langue francaise',
                    url: 'https://www.sfu.ca/education/gs/futurestudents/areas-of-study/programsinfrench.html'
                },
                {
                    title: 'Graduate Diploma in Advanced Professional Studies in Education (GDE)',
                    url: 'https://www.sfu.ca/education/programs/diplomas/gde.html'
                }
            ]
        }
    },
    {
        id: '3.3.2-B-fr-no',
        primary: {
            links: [
                {
                    title: 'Professional Linking Program (PLP)',
                    subtitle: 'Flexible teacher education for working paraprofessionals',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/plp/about.html'
                },
                {
                    title: 'Professional Development Program (PDP)',
                    subtitle: 'SFU’s teacher education program',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/pdp/about.html'
                }
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Graduate Diploma in Advanced Professional Studies in Education (GDE)',
                    url: 'https://www.sfu.ca/education/programs/diplomas/gde.html'
                },
                {
                    title: 'Post Baccalaureate Diplomas (PBD)',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/pdp/about.html'
                },
                {
                    title: 'Master’s Degree Programs',
                    url: 'https://www.sfu.ca/education/programs/graduate-studies.html'
                }
            ]
        }
    },
    {
        id: '3.3.3-A-yes',
        primary: {
            links: [
                {
                    title: 'AHCOTE Teacher Education Program',
                    subtitle: 'Teacher education program in northern BC',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/ahcote/about.html'
                },
                {
                    title: 'Professional Development Program (PDP)',
                    subtitle: 'SFU’s teacher education program',
                    url: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc.html'
                }
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Graduate Diploma in Advanced Professional Studies in Education (GDE)',
                    url: 'https://www.sfu.ca/education/programs/diplomas/gde.html'
                },
                {
                    title: 'Post Baccalaureate Diplomas (PBD)',
                    url: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc.html'
                },
                {
                    title: 'Master’s Degree Programs',
                    url: 'https://www.sfu.ca/education/programs/graduate-studies.html'
                }
            ]
        }
    },
    {
        id: '3.3.3-B.1-fr-yes',
        primary: {
            links: [
                {
                    title: 'Professional Development Program (PDP) | French Module',
                    subtitle: 'SFU’s teacher education program',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/programmes-en-francais.html'
                },
                {
                    title: 'Bachelor of Education (BEd) as a second degree',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/bachelor-of-education-as-a-second-degree/about.html'
                },
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Post Baccalaureate Diploma in French and Education',
                    url: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc/fr-edu-pbd.html'
                },
                {
                    title: 'Programmes en langue francaise',
                    url: 'https://www.sfu.ca/education/gs/futurestudents/areas-of-study/programsinfrench.html'
                },
                {
                    title: 'Graduate Diploma in Advanced Professional Studies in Education (GDE)',
                    url: 'https://www.sfu.ca/education/programs/diplomas/gde.html'
                }
            ]
        }
    },
    {
        id: '3.3.3-B.1-fr-no',
        primary: {
            links: [
                {
                    title: 'Professional Development Program (PDP)',
                    subtitle: 'SFU’s teacher education program',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/pdp/about.html'
                },
                {
                    title: 'Bachelor of Education (BEd) as a second degree',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/bachelor-of-education-as-a-second-degree/about.html'
                },
            ],
        },
        secondary: {
            links: [
                {
                    title: 'Graduate Diploma in Advanced Professional Studies in Education (GDE)',
                    url: 'https://www.sfu.ca/education/programs/diplomas/gde.html'
                },
                {
                    title: 'Post Baccalaureate Diplomas (PBD)',
                    url: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc.html'
                },
                {
                    title: 'Master’s Degree Programs',
                    url: 'https://www.sfu.ca/education/programs/graduate-studies.html'
                }
            ]
        }
    },
    {
        id: '3.2.2.1',
        primary: {
            links: [
                ...degrees.graduateStudies
            ]
        }
    },
    {
        id: '3.2.2.2',
        primary: {
            links: [
                ...degrees.postBach
            ]
        }
    },
    {
        id: '3.1.3',
        primary: {
            links: [
                {
                    title: 'Post Baccalaureate Diploma in Counselling and Human Development',
                    subtitle: 'Review the academic and experience prerequisites for the Master’s in Counselling Psychology programs',
                    url: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc/counselling-human-development-pbd.html'
                },
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Counselling Psychology MA, MEd',
                    url: 'https://www.sfu.ca/education/programs/graduate-studies/programs/counspsych.html'
                }
            ]
        }
    }
]
